import { Component } from '@angular/core';
import { VenueApi } from "../../services/webservice"
import { Router, ActivatedRoute } from '@angular/router';
import { MessageActions } from '../../actions'
import { ErrorHandlerService } from '../../services'
import { Store } from '@ngrx/store'
import { AppState } from "../../reducers"
import { VenueActions } from './venue.actions'

@Component({
	templateUrl: "./venue.html",
	styles: [require("./venue.scss")]
})
export class VenueComponent {

	public showDelete = false;
	public venueId: string;

	constructor(
		private venueApi: VenueApi,
		private route: ActivatedRoute,
		private router: Router,
		private store$: Store<AppState>,
		private messageActions: MessageActions,
		private errorHandler: ErrorHandlerService,
		private venueActions: VenueActions
	) { }

	ngOnInit() {
		this.venueId = this.route.snapshot.params["id"];
	}

	public deleteYes() {
		this.showDelete = false;
		this.venueApi.deleteVenue(this.venueId).subscribe(
			data => {
				this.router.navigate(['/venues'])
				this.store$.dispatch(this.venueActions.venueLoaded(null))
				this.store$.dispatch(this.messageActions.displayMessage("Die Spielstätte wurde erfolgreich gelöscht!", "success"))
			},
			error => {
				let errorMessage = this.errorHandler.getErrorMessage(error, "Es ist ein unerwarteter Fehler aufgetreten.")
				this.store$.dispatch(this.messageActions.displayMessage(errorMessage, "error"))
			});
	}

	public deleteNo() {
		this.showDelete = false;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/venue-components/venue.component.ts